import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const LoyaltyRedeemModal = ({ isOpen, maxRedeemable = 0, onConfirm, onClose }) => {
  const [mode, setMode] = useState("full"); // 'full' | 'partial'
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setMode("full");
      setAmount("");
      setError("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (mode === "full") {
      onConfirm(maxRedeemable);
      return;
    }

    const parsed = Number(amount);

    if (!amount || Number.isNaN(parsed) || parsed <= 0) {
      setError("Enter an amount greater than £0.");
      return;
    }

    if (parsed > maxRedeemable) {
      setError(`Max is £${maxRedeemable.toFixed(2)}.`);
      return;
    }

    onConfirm(parsed);
  };

  return createPortal(
    <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-[9999] p-4">
      <div className="w-full max-w-[380px] bg-white rounded-2xl p-6 shadow-xl">
        <div className="flex justify-between items-center mb-5">
          <h3 className="text-[14px] font-black uppercase tracking-wider text-black font-['Prata',serif]">
            Use Loyalty Rewards
          </h3>
          <button
            className="bg-transparent border-none text-xl text-[#999] cursor-pointer p-0 hover:text-[#333]"
            onClick={onClose}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="space-y-3 py-5">
          <label
            className={`flex items-center gap-3 rounded-xl border-2 px-4 py-3 text-sm font-semibold text-black cursor-pointer transition-colors ${
              mode === "full"
                ? "border-brand-orange bg-brand-orange/10"
                : "border-black/10 hover:border-black/20"
            }`}
          >
            <input
              type="radio"
              name="loyalty-redeem-mode"
              checked={mode === "full"}
              onChange={() => {
                setMode("full");
                setError("");
              }}
              className="accent-brand-orange w-4 h-4"
            />
            Full (£{maxRedeemable.toFixed(2)})
          </label>

          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            <label
              className={`flex flex-1 items-center gap-3 rounded-xl border-2 px-4 py-3 text-sm font-semibold text-black cursor-pointer transition-colors ${
                mode === "partial"
                  ? "border-brand-orange bg-brand-orange/10"
                  : "border-black/10 hover:border-black/20"
              }`}
            >
              <input
                type="radio"
                name="loyalty-redeem-mode"
                checked={mode === "partial"}
                onChange={() => {
                  setMode("partial");
                  setError("");
                }}
                className="accent-brand-orange w-4 h-4"
              />
              Partial
            </label>

            {mode === "partial" && (
              <div className="flex items-center gap-2 sm:w-36">
                <span className="text-black/60 font-semibold">£</span>
                <input
                  type="number"
                  min="0"
                  max={maxRedeemable}
                  step="0.01"
                  autoFocus
                  value={amount}
                  placeholder={`Max ${maxRedeemable.toFixed(2)}`}
                  onChange={(e) => {
                    setAmount(e.target.value);
                    setError("");
                  }}
                  className="flex-1 min-w-0 rounded-lg border border-black/15 px-3 py-2 text-sm font-semibold text-black outline-none focus:border-brand-orange placeholder:text-xs placeholder:font-normal placeholder:text-black/40"
                />
              </div>
            )}
          </div>
        </div>

        {error && <p className="mt-2 text-xs text-red-600">{error}</p>}

        <div className="flex gap-3 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 bg-[#f3f3f3] text-black py-2.5 rounded-full font-bold text-[13px] hover:opacity-80 transition-opacity"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="flex-1 bg-brand-orange text-black py-2.5 rounded-full font-bold text-[13px] hover:opacity-80 transition-opacity"
          >
            Apply
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LoyaltyRedeemModal;
